"use client";

import clsx from "clsx";
import { useRouter } from "next/router";

type Props = {
  className?: string;
};

const LanguageSwitcher = ({ className }: Props) => {
  const router = useRouter();
  const { pathname, asPath, query, locale } = router;
  const isArabic = locale === "ar";

  const switchTo = (target: "en" | "ar") => {
    if (target === locale) return;
    router.push({ pathname, query }, asPath, { locale: target });
  };

  return (
    <div
      className={clsx(
        "inline-flex items-center rounded-full border border-primary overflow-hidden text-sm",
        className
      )}
      role="group"
      aria-label="Language switcher"
    >
      <button
        type="button"
        onClick={() => switchTo("en")}
        className={clsx("px-3 py-1 transition-colors", {
          "bg-primary text-white": !isArabic,
          "bg-transparent text-darkGreen": isArabic,
        })}
        aria-pressed={!isArabic}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => switchTo("ar")}
        className={clsx("px-3 py-1 transition-colors", {
          "bg-primary text-white": isArabic,
          "bg-transparent text-darkGreen": !isArabic,
        })}
        aria-pressed={isArabic}
      >
        عربي
      </button>
    </div>
  );
};

export default LanguageSwitcher;
